module.exports = __webpack_public_path__ + "img/wechatpay.582283a9.png";